import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LanguageService} from '../../../../translation/Services/language.service';
import {Helper} from '../../../../helpers/helper.service';
import {UsersService} from '../../../Services/users.service';
import {CountryService} from '../../../../translation/Services/Country.service';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {environment} from '../../../../../environments/environment';
import {TranslateService} from '@ngx-translate/core';
import {SystemUser} from '../../../../shared/Models/SystemUser';
import {DealerProfileService} from '../../../Services/dealer-profile.service';

@Component({
  selector: 'app-manage-delivery-dealer',
  templateUrl: './manage-delivery-dealer.component.html',
  styleUrls: ['./manage-delivery-dealer.component.scss']
})
export class ManageDeliveryDealerComponent implements OnInit {

  public classicBox;
  public isEdit = false;
  public invoiceDealerId: number;
  public enableSave = true;
  public deliveryUserId: number;
  public lastValue = <any>{};
  public languages = [];
  public countries = [];
  public profiles = [];
  public dealerTypes = [];
  public defaultDealerType;

  constructor(
    private route: ActivatedRoute,
    private languageService: LanguageService,
    private countryService: CountryService,
    public dealerProfileService: DealerProfileService,
    private userService: UsersService,
    private translate: TranslateService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (!Helper.isDefined(params['deliveryId'])) {
        this.invoiceDealerId = params['id'];
      } else {
        this.invoiceDealerId = params['id'];
        this.isEdit = true;
        this.deliveryUserId = params['deliveryId'];
      }

    });
    if (this.isEdit) {
      this.userService.getDealerUser(this.deliveryUserId).subscribe((user) => {
        this.lastValue = {user: user, auth: user};
        this.lastValue.user.language = this.lastValue.user.language.id;
        const lastValueProfiles = [];
        this.lastValue.user.profiles.forEach(profile => {
          lastValueProfiles.push(profile.id);
        });
        this.lastValue.user.profiles = lastValueProfiles;
        this.lastValue.user.country = this.lastValue.user.country.id;
        this.lastValue.user.dealerType = this.lastValue.user.dealerType.id;
      });
    }
    this.languageService.list().subscribe(resp => {
      resp.languages.map((value) => {
        this.languages.push({
          label: value.name,
          value: value.id
        });
      });
      this.countryService.list().subscribe(resp => {
        resp.data.map((value) => {
          this.countries.push({
            label: value.name,
            value: value.id,
          });
        });
        this.dealerProfileService.getProfiles().subscribe(res => {
          res.data.map((value) => {
            this.profiles.push({
              label: value.name,
              value: value.id
            });
          });
          this.userService.DealerTypeList().subscribe(resp => {
            resp.types.map((value) => {
              if (value.name === SystemUser.REGULAR_STORES && !this.defaultDealerType) {
                this.defaultDealerType = value.id;
              }
              this.dealerTypes.push({
                label: this.translate.instant(value.name),
                value: value.id,
              });
            });
            this.classicBox = <FormlyFieldConfig>[
              {
                fieldGroupClassName: 'row',
                key: 'user',
                fieldGroup: [
                  {
                    className: 'col-3 ',
                    type: 'input',
                    key: 'companyName',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.companyName'),
                      required: true,
                      maxLength: environment.maxStringLength,
                    },
                    validation: {
                      messages: {
                        required: this.translate.instant('errors.required'),
                        maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                      },
                    },
                  },
                ],
              },
              {
                className: 'section-label',
                template: '<div><strong>Address</strong></div><hr />',
              },
              {
                fieldGroupClassName: 'row',
                key: 'user',
                fieldGroup: [
                  {
                    className: 'col-3 ',
                    type: 'input',
                    key: 'address',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.address'),
                      required: true,
                      maxLength: environment.maxStringLength,
                    },
                    validation: {
                      messages: {
                        required: this.translate.instant('errors.required'),
                        maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                      },
                    },
                  },
                  {
                    className: 'col-3 ',
                    type: 'input',
                    key: 'zipCode',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.zipCode'),
                      required: true,
                      maxLength: environment.maxStringLength,
                    },
                    validation: {
                      messages: {
                        required: this.translate.instant('errors.required'),
                        maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                      },
                    },
                  },
                  {
                    className: 'col-3 ',
                    type: 'input',
                    key: 'city',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.city'),
                      required: true,
                      maxLength: environment.maxStringLength,
                    },
                    validation: {
                      messages: {
                        required: this.translate.instant('errors.required'),
                        maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                      },
                    },
                  }, {
                    key: 'country',
                    type: 'ng-select',
                    className: 'col-3 ',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.country'),
                      options: this.countries,
                      required: true,
                    },
                  },

                ],
              },


              {
                className: 'section-label',
                template: '<div><strong>Contact</strong></div><hr />',
              },
              {
                fieldGroupClassName: 'row',
                key: 'user',
                fieldGroup: [
                  {
                    className: 'col-3 ',
                    type: 'input',
                    key: 'companyEmail',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.email'),
                      required: true,
                      maxLength: environment.maxStringLength,
                      pattern: environment.emailPattern,
                    },
                    validation: {
                      messages: {
                        pattern: this.translate.instant('errors.invalid'),
                        required: this.translate.instant('errors.required'),
                        maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                      },
                    },
                  },
                  {
                    className: 'col-3',
                    type: 'input',
                    key: 'companyPhone',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.phone'),
                      required: false,
                      maxLength: environment.maxStringLength,
                    },
                  },
                  {
                    className: 'col-3 ',
                    type: 'input',
                    key: 'website',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.website'),
                      required: false,
                      maxLength: environment.maxStringLength,
                    },
                    validation: {
                      messages: {
                        required: this.translate.instant('errors.required'),
                        maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                      },
                    },
                  },
                ],
              },
              {
                className: 'section-label',
                template: '<div><strong>Legal</strong></div><hr />',
              },
              {
                fieldGroupClassName: 'row',
                key: 'user',
                fieldGroup: [
                  {
                    className: 'col-3',
                    type: 'input',
                    key: 'cocNumber',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.cocNumber'),
                      required: false,
                      maxLength: environment.maxStringLength,
                    },
                    validation: {
                      messages: {
                        maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength}),
                        required: this.translate.instant('errors.required')
                      },
                    },
                  },
                  {
                    className: 'col-3 ',
                    type: 'input',
                    key: 'vatNumber',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.vatNumber'),
                      required: false,
                      maxLength: environment.maxStringLength,
                    },
                    validation: {
                      messages: {
                        required: this.translate.instant('errors.required'),
                        maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                      },
                    },
                  },
                ],
              },
              {
                className: 'section-label',
                template: '<div><strong>store</strong></div><hr />',
              },
              {
                fieldGroupClassName: 'row',
                key: 'user',
                fieldGroup: [
                  {
                    key: 'dealerType',
                    type: 'ng-select',
                    className: 'col-3 mb-3',
                    defaultValue: this.defaultDealerType,
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.type'),
                      required: true,
                      options: this.dealerTypes,
                    },
                  },
                ],
              },
              {
                className: 'section-label',
                template: '<div><strong>Admin login credentials</strong></div><hr />',
              },
              {
                fieldGroupClassName: 'row',
                key: 'user',

                fieldGroup: [
                  {
                    className: 'col-3 ',
                    type: 'input',
                    key: 'username',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.username'),
                      required: true,
                      maxLength: environment.maxStringLength,
                    },
                    validation: {
                      messages: {
                        required: this.translate.instant('errors.required'),
                        maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                      },
                    },
                    validators: {
                      username: {
                        expression: (c) => /^[a-zA-Z0-9]+$/.test(c.value),
                        message: (error, field: FormlyFieldConfig) => this.translate.instant('validators.not_valid_username')
                      },
                    }
                  },
                ],
              },
              {
                className: 'section-label',
                template: '<div><strong>Contact person</strong></div><hr />',
              },
              {
                fieldGroupClassName: 'row',
                key: 'user',
                fieldGroup: [
                  {
                    className: 'col-3 ',
                    type: 'input',
                    key: 'firstName',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.firstName'),
                      required: true,
                      maxLength: environment.maxStringLength,
                    },
                    validation: {
                      messages: {
                        required: this.translate.instant('errors.required'),
                        maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                      },
                    },
                  },
                  {
                    className: 'col-3 ',
                    type: 'input',
                    key: 'lastName',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.lastName'),
                      required: true,
                      maxLength: environment.maxStringLength,
                    },
                    validation: {
                      messages: {
                        required: this.translate.instant('errors.required'),
                        maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                      },
                    },
                  },
                  {
                    className: 'col-3 ',
                    type: 'input',
                    key: 'email',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.email'),
                      required: false,
                      pattern: environment.emailPattern,
                      maxLength: environment.maxStringLength,
                    },
                    validation: {
                      messages: {
                        pattern: this.translate.instant('errors.invalid'),
                        required: this.translate.instant('errors.required'),
                        maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                      },
                    },
                  },
                  {
                    className: 'col-3',
                    type: 'input',
                    key: 'phone',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.phone'),
                      required: false,
                      maxLength: environment.maxStringLength,
                    },
                    validation: {
                      messages: {
                        maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength}),
                        required: this.translate.instant('errors.required')
                      },
                    },
                  },
                ],
              },
              {
                className: 'section-label',
                template: '<div><strong>Other</strong></div><hr />',
              },
              {
                fieldGroupClassName: 'row',
                key: 'user',
                fieldGroup: [
                  {
                    key: 'status',
                    type: 'ng-select',
                    className: 'col-3 ',
                    defaultValue: SystemUser.SYSTEMUSER_ACTIVE,
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.status'),
                      required: true,
                      options: [
                        {label: this.translate.instant('global.active'), value: SystemUser.SYSTEMUSER_ACTIVE},
                        {label: this.translate.instant('global.on_hold'), value: SystemUser.SYSTEMUSER_ON_HOLD},
                        {label: this.translate.instant('global.inactive'), value: SystemUser.SYSTEMUSER_INACTIVE},
                      ],
                    },
                  },
                  {
                    key: 'language',
                    type: 'ng-select',
                    className: 'col-3 ',
                    templateOptions: {
                      label: this.translate.instant('doctrine.attributes.language'),
                      options: this.languages,
                      required: true,
                    },
                  },
                  {
                    key: 'profiles',
                    type: 'ng-select',
                    className: 'col-3 ',
                    templateOptions: {
                      label: this.translate.instant('doctrine.invoice_dealer.profile'),
                      options: this.profiles,
                      multiple: true,
                      required: true,
                    },
                  },
                ],
              },
            ];
          });
        });
      });
    });
  }

  enableButton(event) {

    this.enableSave = event;
  }

  submitItem(next: boolean) {
    if (next) {
      const user = JSON.parse(JSON.stringify(this.lastValue.user));
      if (this.isEdit) {
        delete user.employee;
        delete user.id;
        delete user.role;
        delete user.contact;
        delete user.dealerPoints;
        delete user.deliveryContact;
      }
      user.invoiceDealer = this.invoiceDealerId;
      this.userService.manageDealerUser(user, this.isEdit, this.deliveryUserId).subscribe((resp) => {
        this.router.navigateByUrl('/back-office/crm/dealer/' + this.invoiceDealerId + '/show');
      });
    } else {
      this.router.navigateByUrl('/back-office/crm/dealer/' + this.invoiceDealerId + '/show');
    }

  }

}
